import {
  Box,
  Textarea,
  Text,
  VStack,
  HStack,
  IconButton,
  Spinner,
  useToast,
} from '@chakra-ui/react';
import { ArrowLeft } from 'lucide-react';
import { useNavigate, useParams } from 'react-router-dom';
import { useState } from 'react';
import { updateWhatsAppAbout } from '../../../hooks/whatsapp_number';

const MAX_LENGTH = 2056;

export default function EditAboutPage() {
  const navigate = useNavigate();
  const { orgId, whatsappNumberId } = useParams();
  const toast = useToast();

  const [about, setAbout] = useState('');
  const [saving, setSaving] = useState(false);

  const handleSave = async () => {
    if (!orgId) return;

    setSaving(true);

    const res = await updateWhatsAppAbout(
      whatsappNumberId || '',
      orgId,
      about.trim(),
    );

    setSaving(false);

    if (res.success) {
      toast({
        title: 'About updated',
        status: 'success',
        duration: 1500,
      });
      navigate(-1);
    } else {
      toast({
        title: 'Update failed',
        description: 'Unable to update About section',
        status: 'error',
        duration: 3000,
      });
    }
  };

  return (
    <Box bg="white" minH="100vh">
      {/* Header */}
      <HStack px={4} py={3} justify="space-between">
        <IconButton
          aria-label="Back"
          icon={<ArrowLeft />}
          variant="ghost"
          onClick={() => navigate(-1)}
        />

        <Text fontWeight="semibold">About</Text>

        {saving ? (
          <Spinner size="sm" />
        ) : (
          <Text color="#25D366" cursor="pointer" onClick={handleSave}>
            Save
          </Text>
        )}
      </HStack>

      {/* Content */}
      <VStack px={4} mt={4} spacing={2}>
        <Textarea
          value={about}
          onChange={(e) => setAbout(e.target.value.slice(0, MAX_LENGTH))}
          placeholder="Add a short description about your business"
          resize="none"
          minH="120px"
          autoFocus
        />

        <Text fontSize="xs" color="gray.500" alignSelf="flex-end">
          {about.length} / {MAX_LENGTH}
        </Text>
      </VStack>
    </Box>
  );
}
